module.exports = __webpack_public_path__ + "static/media/file-video.62f1821b.svg";